import { Component, Input, OnInit } from '@angular/core';
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';
import { BrowseConfig } from '@core/bean/browse-config';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { CommodityInformationService } from '../../../../routes/jy-srm/commodity/commodity-information/commodity-information.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
  selector: 'commodity-info',
  templateUrl: './commodity-info.component.html',
  styles: []
})
export class CommodityInfoComponent implements BrowseComponent, OnInit {

  static componentName = 'CommodityInfoComponent';

  @Input() config: BrowseConfig;
  @Input() onCancel: () => void;
  @Input() onOk: (data: (any | [any])) => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};

  constructor(
    private commonsService:CommonsService,
    private modalService:NzModalService,
    private commodityInfoService:CommodityInformationService,
  ) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return commodityInfoService.query(params);
    }
  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }


}
